import {Inject, ModuleWithProviders, NgModule} from "@angular/core";
import {KeyboardShortcutsService} from "./ng-keyboard-shortcuts.service";
import {KeyboardShortcutsSelectService} from "./ng-keyboard-shortcuts-select.service";
import {CommonModule} from "@angular/common";
import {KeyboardShortcutComponent} from "./keyboard-shortcut.component";
import {EVENT_MANAGER_PLUGINS} from "@angular/platform-browser";
import {KeyboardShortcutsPlugin} from "./ng-keyboard-shortcuts.plugin";
import {KeyboardShortcutsComponent} from "./ng-keyboard-shortcuts.component";

@NgModule({
    imports: [CommonModule],
    declarations: [
        KeyboardShortcutComponent,
      KeyboardShortcutsComponent
    ],
    exports: [
        KeyboardShortcutComponent,
      KeyboardShortcutsComponent
    ]
})
export class NgKeyboardShortcutsModule {
    public static forRoot(): ModuleWithProviders<NgKeyboardShortcutsModule> {
        return {
            ngModule: NgKeyboardShortcutsModule,
            providers: [
                KeyboardShortcutsService,
                KeyboardShortcutsSelectService,
                {
                    multi: true,
                    provide: EVENT_MANAGER_PLUGINS,
                    useClass: KeyboardShortcutsPlugin
                }
            ]
        };
    }
}
